import 'react-notifications-component/dist/theme.css';
import React, { useEffect, useLayoutEffect, useState } from 'react';
import ReactGA from 'react-ga';
import { ReactNotifications } from 'react-notifications-component';
import { Redirect, Route, Switch } from 'react-router-dom';

import axios from 'axios';

import { useGlobalContext } from '../AppContext';
import {
  fetchCoinDataFromCoingecko,
  retrieveAndPrepareAddressData,
  tryToReconnect,
} from '../utils/hooks';
import { Button } from '../components/Button';
import { BuyAndSell } from './BuyAndSell';
import { Dashboard } from './Dashboard';
import { Favorites } from './Favorites';
import { FloatMenu } from '../components/FloatMenu';
import { Header } from '../components/Header';
import { HeatMap } from './HeatMap';
import { Loading } from '../components/Loading';
import { MyPortfolio } from './MyPortfolio';
import { NFTAndENS } from './NFTAndENS';
import { Profile } from './Profile';
import { Reminders } from './Reminders';
import { Settings } from './Settings';
import { StatisticsAndFees } from './StatisticsAndFees';
import { VestingCalendar } from './VestingCalendar';
import { Whales } from './Whales';

import './animate.css';
import './Layout.scss';

export function WebRouter() {
  const {
    systemReady,
    setSystemReady,
    isMobile,
    setIsMobile,
    address,
    demoMode,
    preparing,
    allow,
    setAllow,
    config,
    tokensMoonriver,
  } = useGlobalContext();
  const [passcode, setPasscode] = useState<string>('');
  const [disabled, setDisabled] = useState<boolean>(false);
  const [error, setError] = useState('');
  const [redirectContent, setRedirectContent] = useState<boolean>(false);
  const [theme, setTheme] = useState('light');

  useEffect(() => {
    const handleThemeChange = () => {
      const newTheme = document.body.classList.contains('light') ? 'light' : 'dark';
      setTheme(newTheme);
    };

    handleThemeChange();

    const observer = new MutationObserver(handleThemeChange);
    const config = { attributes: true, attributeFilter: ['class'] };
    observer.observe(document.body, config);

    return () => {
      observer.disconnect();
    };
  }, []);


  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  useLayoutEffect(() => {
    const updateSize = () => {
      setIsMobile(window.innerWidth < 1025 ? true : false);
    };
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  useLayoutEffect(() => {
    const updateSize = (e: any) => {
      if (e.target.classList.contains('dropdown-item')) {
      } else {
        if (document.getElementsByClassName('dropdown')[0]) {
          document.getElementsByClassName('dropdown')[0].classList.remove('open');
        }
        if (document.getElementsByClassName('dropdown')[1]) {
          document.getElementsByClassName('dropdown')[1].classList.remove('open');
        }
        if (document.getElementsByClassName('dropdown')[2]) {
          document.getElementsByClassName('dropdown')[2].classList.remove('open');
        }
      }
    };
    window.addEventListener('click', updateSize);
    return () => window.removeEventListener('click', updateSize);
  }, []);

  // fetch details
  fetchCoinDataFromCoingecko();

  // check for connection
  tryToReconnect();

  const handleOnChange = (e: any) => {
    setError('');
    setPasscode(e.target.value);
  };

  const retrieveData = async () => {
    setDisabled(true);
    const response = await axios({
      url: `${process.env.REACT_APP_API}/passcode.php?passcode=${passcode}`,
      withCredentials: true,
    });
    setDisabled(false);

    if (response && response.data) {
      localStorage.setItem('allowed', '1');
      setAllow(true);
    } else {
      setAllow(false);
      setError('Access denied!');
    }
  };

  // retrieve data
  retrieveAndPrepareAddressData();

  useEffect(() => {
    if (!address || preparing) {
      if (document.location.pathname.length > 1) {
        //document.location.href = '/';
      }

      if (document.location.pathname.length > 1) {
        setRedirectContent(true);
      } else {
        setRedirectContent(false);
      }
    } else {
      setRedirectContent(false);
    }
  }, [address, document.location.pathname, preparing]);

  useEffect(() => {
    if (allow && tokensMoonriver && document.getElementById('bgLayout4')) {
      setTimeout(() => {
        try {
          document.getElementById('bgLayout4')!.classList.add('hidden');
        } catch (e: any) {
          console.log(e);
        }
        setSystemReady(true);
      }, 5000);
    }
  }, [allow, tokensMoonriver]);

  function renderLayoutContent() {
    const renderContent = (
      <>
        {(!address || !config) &&
          !systemReady &&
          demoMode &&
          localStorage.getItem('firstRun') !== '1' && (
            <div className={`bgLayout4 ${isMobile ? 'mobile' : ''}`} id="bgLayout4">
              <div className="animate__animated animate__fadeIn">
                <img src="/logo-light.svg" alt="" />
              </div>
              <div className="animate__animated animate__fadeIn animate__delay-1s secondStep">
                Walletscan is the ultimate tool for tracking your crypto assets from different
                networks and any crypto wallets.
              </div>
              <div className="animate__animated animate__fadeIn animate__delay-2s thirdStep">
                Let's explore more...
              </div>
            </div>
          )}

        {preparing && <Loading inline={true} />}
        <Header />
        <Switch>
          <Route path="/my-portfolio">
            <MyPortfolio />
          </Route>
          <Route path="/nft-ens">
            <NFTAndENS />
          </Route>
          <Route path="/heat-map">
            <HeatMap />
          </Route>
          <Route path="/buy-sell">
            <BuyAndSell />
          </Route>
          <Route path="/statistics-fees">
            <StatisticsAndFees />
          </Route>
          <Route path="/vesting-calendar">
            <VestingCalendar />
          </Route>
          <Route path="/favorites">
            <Favorites />
          </Route>
          <Route path="/whales">
            <Whales />
          </Route>
          <Route path="/reminders">
            <Reminders />
          </Route>
          <Route path="/profile">
            <Profile />
          </Route>
          <Route path="/settings">
            <Settings />
          </Route>
          <Route path={['/']}>
            <Dashboard />
          </Route>
        </Switch>
        <div className={`services-we-use-${theme} hidden-m`}>
          <div className="text">List of services that we’re using to calculate data:</div>
          <div className="images">
            <img src="/services/coingecko.svg" alt="" />
            <img src="/services/moralis.svg" alt="" />
            <img src="/services/etherscan.svg" alt="" />
            <img src="/services/bscscan.svg" alt="" />
            <img src="/services/moonbeamscan.svg" alt="" />
            <img src="/services/moonriverscan.svg" alt="" />
            <img src="/services/polygonscan.svg" alt="" />
            <img src="/services/snowtrace.svg" alt="" />
            <img src="/services/mantle.svg" alt="" />
          </div>
        </div>
        <div className="float-menu-container">
          <FloatMenu />
        </div>
      </>
    );

    return (
      <>
        <ReactNotifications />
        <div className="content-wrapper">
          <div className="content">{renderContent}</div>
        </div>
      </>
    );
  }

  return (
    <>
      {redirectContent && <Redirect to="/" />}
      {!tokensMoonriver && <Loading />}
      {!allow && tokensMoonriver && (
        <>
          {!isMobile && <div className="bgLayout" style={{ backgroundImage: 'url(blur.png)' }} />}
          {isMobile && (
            <div className="bgLayout mobile" style={{ backgroundImage: 'url(blur3.png)' }} />
          )}
          <div className="passcode">
            <div className="passcode-container">
              <div className="search-form center">
                <img className="logo" src="/icon-light.svg" alt="" />
                <div className="search-input">
                  <input
                    onChange={handleOnChange}
                    disabled={disabled}
                    type="text"
                    placeholder="Enter the passcode"
                  />
                </div>
                <div className="search-button">
                  <Button
                    onClick={retrieveData}
                    disabled={disabled}
                    color="three"
                    label="Login"
                    size="large"
                  />
                </div>
                {error && (
                  <div className="error-message-container">
                    <img src="/icons/warning-solid.svg" />
                    {error}
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
      {allow && renderLayoutContent()}
    </>
  );
}
